import type { Receita, StatusReceita } from '../../types';
import { fmtBRL, fmtData } from './formatadores';

const BADGE: Record<StatusReceita, { t: string; c: string }> = {
  previsto: { t: 'Previsto', c: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300' },
  parcial: { t: 'Parcial', c: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300' },
  recebido: { t: 'Recebido', c: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300' },
};

interface Props {
  r: Receita;
  onEditar: (r: Receita) => void;
  onReceber: (r: Receita) => void;
  onExcluir: (r: Receita) => void;
}

export function LinhaReceita({ r, onEditar, onReceber, onExcluir }: Props) {
  const badge = BADGE[r.status];
  const div = r.divisao ?? [];
  return (
    <tr className="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/60 dark:hover:bg-slate-800/40">
      <td className="px-3 py-2 align-top">
        <div className="text-xs font-medium text-slate-800 dark:text-slate-100">{r.numero_processo}</div>
        <div className="text-[11px] text-slate-500 dark:text-slate-400 truncate max-w-[200px]">{r.cliente_nome || '—'}</div>
        {div.length > 0 && (
          <div className="mt-1 flex flex-wrap gap-1">
            {div.map((d) => (
              <span key={d.id ?? d.socio_id} title={`${d.socio_nome}: ${fmtBRL(d.valor)}`}
                className="inline-block text-[10px] px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                {(d.socio_nome || '?').split(' ')[0]} · {fmtBRL(d.valor)}
              </span>
            ))}
          </div>
        )}
      </td>
      <td className="px-3 py-2 text-right tabular-nums text-xs text-slate-600 dark:text-slate-300">{fmtBRL(r.valor_contratuais)}</td>
      <td className="px-3 py-2 text-right tabular-nums text-xs text-slate-600 dark:text-slate-300">{fmtBRL(r.valor_sucumbencia)}</td>
      <td className="px-3 py-2 text-right tabular-nums text-xs font-semibold text-slate-800 dark:text-slate-100">{fmtBRL(r.valor_total)}</td>
      <td className="px-3 py-2 text-center">
        <span className={`inline-block text-[10px] px-2 py-0.5 rounded-full font-medium ${badge.c}`}>{badge.t}</span>
        {r.status !== 'previsto' && r.valor_recebido > 0 && (
          <div className="text-[10px] text-slate-400 mt-0.5 tabular-nums">{fmtBRL(r.valor_recebido)}</div>
        )}
      </td>
      <td className="px-3 py-2 text-[11px] text-slate-500 dark:text-slate-400 whitespace-nowrap">
        {r.status === 'recebido' || r.status === 'parcial'
          ? <>recebido {fmtData(r.data_recebimento)}</>
          : <>prev. {fmtData(r.data_prevista)}</>}
      </td>
      <td className="px-3 py-2 text-right whitespace-nowrap">
        {r.status !== 'recebido' && (
          <button onClick={() => onReceber(r)} title="Marcar como recebido"
            className="text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 px-1">✓</button>
        )}
        <button onClick={() => onEditar(r)} title="Editar" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 px-1">✎</button>
        <button onClick={() => onExcluir(r)} title="Excluir" className="text-slate-400 hover:text-rose-600 dark:hover:text-rose-400 px-1">🗑</button>
      </td>
    </tr>
  );
}
